import React from 'react';
import { useTranslation } from 'react-i18next';

// Bascule FR / EN. i18next-browser-languagedetector mémorise le choix
// (localStorage + cookie, réglages par défaut de la lib) : une fois
// changée à la main, la langue ne revient pas se caler sur celle du
// navigateur au prochain chargement.
const LanguageSwitcher = ({ className = '' }) => {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'fr').slice(0, 2);

  const switchTo = (lng) => {
    if (lng !== current) i18n.changeLanguage(lng);
  };

  return (
    <div
      className={`flex items-center gap-1.5 font-mono text-xs tracking-[0.1em] ${className}`}
      aria-label={t('header.language_switcher.label')}
    >
      <button
        onClick={() => switchTo('fr')}
        className={`uppercase transition-colors duration-200 ${
          current === 'fr' ? 'text-ember' : 'text-gray-500 hover:text-ember'
        }`}
        aria-current={current === 'fr'}
      >
        FR
      </button>
      <span className="text-gray-600">/</span>
      <button
        onClick={() => switchTo('en')}
        className={`uppercase transition-colors duration-200 ${
          current === 'en' ? 'text-ember' : 'text-gray-500 hover:text-ember'
        }`}
        aria-current={current === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
